import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type UploadAnalyticsCommonParams } from './uploadAnalyticsTypes';
import META from './useTrackUploadPartError.meta';

export type UseTrackUploadPartErrorParams = UploadAnalyticsCommonParams & {
  part_number: number;
  part_size_bytes?: number;
  retry_count?: number;
  max_retry_count?: number;
  error_message: string;
  error_name?: string;
  error_status_code?: number;
  is_retryable?: boolean;
  upload_url_type: 'primary' | 'fallback';
};

export const useTrackUploadPartError = () => {
  const { track } = useAnalyticsUtilities();

  const trackUploadPartError = useCallback(
    (params: UseTrackUploadPartErrorParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackUploadPartError };
};
